import React from 'react';
import { Flex, Text } from '@radix-ui/themes';
import classNames from 'classnames';

interface Props {
  className?: string;
  visible: boolean;
  expired: boolean;
  hasUserBids?: boolean;
}

const BiddingCardWinnerMessage = ({ className, visible, expired, hasUserBids = false }: Props) => {
  if (visible) {
    return (
      <Flex
        justify="center"
        className={classNames(
          "w-full",
          className
        )} >
        <Text className="justify-end text-green-700">{
          expired ? "You won this lot." :
            "You are the current highest bidder."
        }</Text>
      </Flex>
    );
  }

  // Not the current winner
  if (expired) {
    if (hasUserBids) {
      return (
        <Flex
          justify="center"
          className={classNames(
            "w-full",
            className
          )} >
          <Text className="justify-end text-red-700">You were outbid on this lot.</Text>
        </Flex>
      );
    }
    return null;
  }

  if (hasUserBids) {
    return (
      <Flex
        justify="center"
        className={classNames(
          "w-full",
          className
        )} >
        <Text className="justify-end text-orange-600">You&apos;ve been outbid.</Text>
      </Flex>
    );
  }

  return null;
}

export default BiddingCardWinnerMessage
